import config from './config'
window.onresize = function () {
  fnResize();
}
window.onload = function () {
  fnResize();
}
setTimeout(()=>{
  fnResize();
},1000)
function fnResize() {
  var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
  let num = deviceWidth / 10
  if(num>160){
    document.documentElement.style.fontSize = '160px';
  }else if(num<98){
    if(!config.urlList.isShowWeb){
      document.documentElement.style.fontSize = '160px';
    }else{
      document.documentElement.style.fontSize = num + 'px';
    }
  }else{
    document.documentElement.style.fontSize = num + 'px';
  }
}